import styled from 'styled-components';
import {getCategoryIcon} from '@/components/CategoryIcon';
import {FranchiseItem} from '@/map/@types';
import {FlexCenter} from '@/styled-components';
import {getCategoryId, getCategoryInfoFromAlias} from '@/utils';
import {ColorCircleWithIcon} from '../Markers';

interface IProps {
  item: FranchiseItem;
}

export const Logo = ({item}: IProps) => {
  return (
    <Root>
      {!!item.metadata?.logoUrl ? (
        <LogoAvatar src={item.metadata?.logoUrl} />
      ) : (
        <CategoryIcon item={item} />
      )}
    </Root>
  );
};

const CategoryIcon = ({item}: IProps) => {
  const alias = item.businessItems?.[0]?.alias;
  const {category} = getCategoryInfoFromAlias(alias as any);
  const categoryId = getCategoryId(category as any);
  const icon = getCategoryIcon(categoryId, 22);

  return <ColorCircleWithIcon size="large" icon={icon} />;
};

const Root = styled(FlexCenter)`
  flex-shrink: 0;
`;

const LogoAvatar = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 50%;
`;
